import React, { useEffect, useState } from 'react';
import { Clock, TrendingUp, TrendingDown, Zap } from 'lucide-react';

const PerformanceMonitor = ({ onLoadTimeChange }) => {
  const [loadTime, setLoadTime] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [performanceScore, setPerformanceScore] = useState('Good');

  const startTiming = () => {
    setIsLoading(true);
    const startTime = performance.now();
    
    return () => {
      const endTime = performance.now();
      const duration = endTime - startTime;
      setLoadTime(duration);
      setIsLoading(false);
      
      // Calculate performance score
      let score = 'Excellent';
      if (duration > 3000) {
        score = 'Poor';
      } else if (duration > 1500) {
        score = 'Fair';
      } else if (duration > 800) {
        score = 'Good';
      }
      
      setPerformanceScore(score);
      
      if (onLoadTimeChange) {
        onLoadTimeChange(duration, score);
      }
    };
  };

  // Expose timing functions
  useEffect(() => {
    if (window) {
      window.startPerformanceTiming = startTiming;
    }
    
    return () => {
      if (window) {
        window.startPerformanceTiming = null;
      }
    };
  }, []);

  const getScoreColor = (score) => {
    switch (score) {
      case 'Excellent': return 'text-green-600';
      case 'Good': return 'text-blue-600';
      case 'Fair': return 'text-yellow-600';
      case 'Poor': return 'text-red-600';
      default: return 'text-gray-600';
    }
  };

  const getScoreIcon = (score) => {
    switch (score) {
      case 'Excellent': return <Zap className="h-4 w-4 text-green-600" />;
      case 'Good': return <TrendingUp className="h-4 w-4 text-blue-600" />;
      case 'Fair': return <Clock className="h-4 w-4 text-yellow-600" />;
      case 'Poor': return <TrendingDown className="h-4 w-4 text-red-600" />;
      default: return <Clock className="h-4 w-4 text-gray-600" />;
    }
  };

  if (process.env.NODE_ENV !== 'development') {
    return null; // Only show in development
  }

  return (
    <div className="fixed bottom-4 right-4 bg-white rounded-lg shadow-lg border border-gray-200 p-3 z-50">
      <div className="flex items-center space-x-2">
        {getScoreIcon(performanceScore)}
        <div className="text-sm">
          <div className="font-medium text-gray-900">Performance</div>
          <div className={`${getScoreColor(performanceScore)} font-medium`}>
            {isLoading ? 'Loading...' : `${loadTime.toFixed(0)}ms - ${performanceScore}`}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PerformanceMonitor;